var Flowcor = Flowcor || {};

Flowcor.Term = Flowcor.Term || {};

Flowcor.Term.Term = function () {
  var _commentSlider = '.term-filter12';
  var _prevArrow = '.prev-comment';
  var _nextArrow = '.next-comment';

  var _slider = function () {
    var carousel = $(_commentSlider);
    if (carousel.length) {
      carousel.owlCarousel({
        singleItem: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            dots: true,
            items: 1,
          },
          576: {
            items: 1
          },
        }
      });
    }
  }

  var _init = function () {
    _slider();
  }

  /** PUBLIC API **/
  return {
    init: function () { return _init(); }
  };

}();

jQuery(document).ready(function () {
  Flowcor.Term.Term.init();
});
